import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import ActionChatRoom from "../actions/actionCompDrawer";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  paperAnchorRight: {
    width: "50vw!important"
  }
});
export default function SwipeableTemporaryDrawer({ toggleAction, state, handleDelete }) {
  // const classes = useStyles();

  return (
    <React.Fragment>
      <Drawer
        anchor={"right"}
        open={state}
        onClose={toggleAction}
        onOpen={toggleAction}
        // className={classes.paperAnchorRight}
      >
        <Container>
          <Grid container spacing={0} style={{ padding: 5 }}>
            <Grid item xs={6} align="left">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
                size="small"
                onClick={() => toggleAction()}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={6} align="right">
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => handleDelete(state.id)}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Container>
          <Grid container spacing={0} style={{ padding: 5 }}>
            <Grid item xs={12} align="left">
              <ActionChatRoom id={state.id} />
            </Grid>
          </Grid>
        </Container>
      </Drawer>
    </React.Fragment>
  );
}
